import {GraphQLError} from 'graphql';

export const codeIs = (code: string) => (e: GraphQLError) => e.extensions?.code === code


export const isUnauthorized = codeIs('UNAUTHORIZED')
export const isAlreadyExists = codeIs('ENTITY_ALREADY_EXISTS')
